import { render, staticRenderFns } from "./BorderRadiusCustoms.vue?vue&type=template&id=0e5ce426&scoped=true"
import script from "./BorderRadiusCustoms.vue?vue&type=script&lang=js"
export * from "./BorderRadiusCustoms.vue?vue&type=script&lang=js"
import style0 from "./BorderRadiusCustoms.vue?vue&type=style&index=0&id=0e5ce426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5ce426",
  null
  
)

export default component.exports